import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "p-login-heading-2 u-mb-10-sp u-mb-16-pc" }, [
  /*#__PURE__*/_createTextVNode("マイナビ転職AGENTにおける"),
  /*#__PURE__*/_createElementVNode("br", { class: "u-lg-hidden" }),
  /*#__PURE__*/_createTextVNode("セキュリティ強化について")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "u-text-center u-mb-10-sp u-mb-16-pc" }, [
  /*#__PURE__*/_createTextVNode("マイナビ転職AGENTではセキュリティの強化を目的に"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("2点の仕様変更を行いました。")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-mail-security-box1" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "p-mail-security-list1 --numbered --fit-content" }, [
    /*#__PURE__*/_createElementVNode("li", null, "ログインIDとメールアドレス1が同一となるように仕様変更を実施"),
    /*#__PURE__*/_createElementVNode("li", null, "ご本人様確認としてメールアドレス認証を追加")
  ])
], -1)
const _hoisted_4 = { class: "p-mail-security-block u-mt-16-sp u-mt-24-pc" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "設定する", -1)
const _hoisted_7 = [
  _hoisted_6
]

import { useRouter } from 'vue-router';
import MailSecurityPopupView from './MailSecurityPopupView.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecuritySettingPopupView',
  props: {
  isCloseable: {
    type: Boolean,
    default: true
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props

const router = useRouter();




const goToSetting = () => {
  emit('close');
  router.push({ name: 'mss02' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MailSecurityPopupView, {
    isShowCloseBtnPopup: __props.isCloseable,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
    modalSize: "large"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          class: "p-recommend-button --type-1 --width-1",
          href: "",
          onClick: _withModifiers(goToSetting, ["prevent"])
        }, _hoisted_7, 8, _hoisted_5)
      ])
    ]),
    _: 1
  }, 8, ["isShowCloseBtnPopup"]))
}
}

})